import { Component, computed, inject } from '@angular/core';
import { LayoutService } from './service/app.layout.service';

import { DrawerModule } from 'primeng/drawer';
import { AuthService } from '@lib/auth/data-access';
import { BroadcastService } from '@lib/shared/data-access';
import { BroadcastChannelType } from '@lib/shared/models';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-profilemenu',
    templateUrl: './app.profilesidebar.component.html',
    standalone: true,
    imports: [
        DrawerModule,
        RouterModule
    ]
})
export class AppProfileSidebarComponent {

    public layoutService = inject(LayoutService);
    public authService = inject(AuthService);
    private router = inject(Router);
    private broadcastService = inject(BroadcastService);

   visible = computed(
        () => this.layoutService.layoutState().profileSidebarVisible,
    );

    onDrawerHide() {
    // TODO fix with primeng animation transitions.
    // Create bug in GitHub for primeng to fix it. The animations take too long and the overlay is still there, users can't click anything for a bit.
    const maskElement = document.querySelector(
        '.p-drawer-mask'
    );
    if (maskElement) {
        maskElement.classList.remove('p-overlay-mask')
    }
      this.layoutService.layoutState.update((state) => ({
          ...state,
          profileSidebarVisible: false,
      }));
    }

    onThemeChangeClick() {
        this.layoutService.showThemeSidebar();
    }

    onLogOutClick() {
        this.authService.logout();        
        
        //Let the other tabs and windows know that the user has logged out
        this.broadcastService.postMessage(BroadcastChannelType.Logout, 'Logout');
    }

     onProfileEditClick() {
        this.router.navigate(['/profile']);
        this.onDrawerHide()
    }
}